import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import Header from '@/components/generals/header'
import Footer from '@/components/generals/footer'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#contenido'
                className='sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[60] focus:rounded-full focus:bg-foreground focus:px-5 focus:py-2.5 focus:text-sm focus:font-semibold focus:text-background'
            >
                Saltar al contenido
            </a>

            <Header />

            <main id='contenido' className='flex-1'>
                {children}
            </main>

            <Footer />
        </div>
    )
}
